/* MD Megamenú: barra con paneles (hover y teclado) y drawer móvil con foco atrapado */
(function () {
  'use strict';

  var ROOT = '.md-megamenu';
  var DRAWER_ID = 'md-megamenu-drawer';
  var TRIGGER = '[aria-controls="' + DRAWER_ID + '"]';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var OPEN_CLASS = 'md-megamenu__tab--open';
  var SCROLL_LOCK = 'scroll-lock';

  var desktopQuery = window.matchMedia('(min-width: 992px)');
  /* Solo con puntero real: en táctil el toque emula mouseenter y abriría el panel y el enlace a la vez */
  var hoverQuery = window.matchMedia('(hover: hover)');
  var instances = new WeakMap();

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function byId(container, id) {
    return container.querySelector('[id="' + id + '"]');
  }

  function initSection(container) {
    if (container.dataset.mdInit) return;
    container.dataset.mdInit = 'true';

    /* ---------- Barra de escritorio ---------- */
    var bar = container.querySelector('[data-md-bar]');
    var tabs = container.querySelectorAll('[data-md-tab]');

    /* Publica la altura de la barra fija en --md-megamenu-height (la usan otras secciones con sticky,
       p. ej. el resumen del carrito), igual que hace md-cabecera con --md-cabecera-height */
    var HEIGHT_VAR = '--md-megamenu-height';
    var heightObserver = null;
    function updateHeight() {
      var sticky = container.classList.contains('md-megamenu--sticky') && bar && getComputedStyle(bar).display !== 'none';
      var h = sticky ? bar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty(HEIGHT_VAR, Math.round(h) + 'px');
    }
    updateHeight();
    if (bar && 'ResizeObserver' in window) {
      heightObserver = new ResizeObserver(updateHeight);
      heightObserver.observe(bar);
    } else {
      window.addEventListener('resize', updateHeight);
    }

    function setTab(tab, open) {
      var toggle = tab.querySelector('[data-md-toggle]');
      tab.classList.toggle(OPEN_CLASS, open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeTabs(except) {
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i] !== except) setTab(tabs[i], false);
      }
    }

    function openTab(tab) {
      closeTabs(tab);
      setTab(tab, true);
    }

    function openTabOf(el) {
      return el.closest('.' + OPEN_CLASS);
    }

    for (var t = 0; t < tabs.length; t++) {
      (function (tab) {
        tab.addEventListener('mouseenter', function () {
          if (desktopQuery.matches && hoverQuery.matches) openTab(tab);
        });
        tab.addEventListener('mouseleave', function () {
          if (hoverQuery.matches) setTab(tab, false);
        });
      })(tabs[t]);
    }

    if (bar) {
      bar.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-md-toggle]');
        if (!toggle) return;
        var tab = toggle.closest('[data-md-tab]');
        if (tab.classList.contains(OPEN_CLASS)) {
          setTab(tab, false);
        } else {
          openTab(tab);
        }
      });

      bar.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        var tab = openTabOf(e.target);
        if (!tab) return;
        e.preventDefault();
        setTab(tab, false);
        var toggle = tab.querySelector('[data-md-toggle]');
        if (toggle) toggle.focus();
      });

      /* Al salir con el tabulador de una pestaña abierta, su panel se cierra */
      bar.addEventListener('focusout', function (e) {
        var tab = openTabOf(e.target);
        if (!tab) return;
        if (e.relatedTarget && tab.contains(e.relatedTarget)) return;
        setTab(tab, false);
      });
    }

    /* ---------- Drawer móvil ---------- */
    var drawer = container.querySelector('[data-md-drawer]');
    var scrim = container.querySelector('[data-md-scrim]');
    if (!drawer || !scrim) return;

    var closeBtn = drawer.querySelector('[data-md-close]');
    var backBtn = drawer.querySelector('[data-md-back]');
    var title = drawer.querySelector('[data-md-drawer-title]');
    var level1 = drawer.querySelector('[data-md-level1]');
    var subs = drawer.querySelectorAll('[data-md-sub]');
    var subButtons = drawer.querySelectorAll('[data-md-open-sub]');
    var body = drawer.querySelector('.md-megamenu__drawer-body');

    var lastTrigger = null;
    var currentSubBtn = null;
    var lockedByUs = false;
    var inerted = [];

    /* Diálogo modal: el resto de la página queda inerte (sin foco ni lectura) mientras el drawer
       está abierto. Se marcan los hermanos de cada ancestro hasta body, salvo el scrim (debe
       recibir el clic de cierre) y lo que ya estuviera inerte por otro componente. */
    function setInert() {
      var node = drawer;
      while (node && node !== document.body) {
        var parent = node.parentElement;
        if (!parent) break;
        var kids = parent.children;
        for (var i = 0; i < kids.length; i++) {
          var kid = kids[i];
          if (kid === node || kid === scrim || kid.hasAttribute('inert')) continue;
          if (/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(kid.tagName)) continue;
          kid.setAttribute('inert', '');
          inerted.push(kid);
        }
        node = parent;
      }
    }

    function clearInert() {
      for (var i = 0; i < inerted.length; i++) inerted[i].removeAttribute('inert');
      inerted = [];
    }

    /* La hamburguesa vive en la cabecera, fuera de esta sección: se sincroniza por aria-controls */
    function syncTriggers(expanded) {
      var triggers = document.querySelectorAll(TRIGGER);
      for (var i = 0; i < triggers.length; i++) {
        triggers[i].setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    function showLevel1() {
      for (var i = 0; i < subs.length; i++) subs[i].hidden = true;
      for (var j = 0; j < subButtons.length; j++) subButtons[j].setAttribute('aria-expanded', 'false');
      level1.hidden = false;
      backBtn.hidden = true;
      title.textContent = '';
      if (body) body.scrollTop = 0;
    }

    function openSub(btn) {
      var sub = byId(drawer, btn.getAttribute('aria-controls'));
      if (!sub) return;
      currentSubBtn = btn;
      level1.hidden = true;
      sub.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      backBtn.hidden = false;
      title.textContent = sub.dataset.mdTitle || '';
      if (body) body.scrollTop = 0;
      backBtn.focus();
    }

    function goBack() {
      showLevel1();
      if (currentSubBtn) currentSubBtn.focus();
      currentSubBtn = null;
    }

    function lockScroll() {
      var html = document.documentElement;
      if (html.hasAttribute(SCROLL_LOCK)) return;
      html.setAttribute(SCROLL_LOCK, '');
      lockedByUs = true;
    }

    function unlockScroll() {
      if (!lockedByUs) return;
      document.documentElement.removeAttribute(SCROLL_LOCK);
      lockedByUs = false;
    }

    function openDrawer(trigger) {
      if (!drawer.hidden) return;
      lastTrigger = trigger || document.activeElement;
      showLevel1();
      scrim.hidden = false;
      drawer.hidden = false;
      lockScroll();
      syncTriggers(true);
      setInert();
      closeBtn.focus();
    }

    function closeDrawer() {
      if (drawer.hidden) return;
      drawer.hidden = true;
      scrim.hidden = true;
      unlockScroll();
      clearInert();
      syncTriggers(false);
      if (lastTrigger && isVisible(lastTrigger)) lastTrigger.focus();
      lastTrigger = null;
    }

    function toggleDrawer(trigger) {
      if (drawer.hidden) {
        openDrawer(trigger);
      } else {
        closeDrawer();
      }
    }

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-md-close]')) {
        closeDrawer();
        return;
      }
      if (e.target.closest('[data-md-back]')) {
        goBack();
        return;
      }
      var subBtn = e.target.closest('[data-md-open-sub]');
      if (subBtn) openSub(subBtn);
    });

    scrim.addEventListener('click', closeDrawer);

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        closeDrawer();
        return;
      }
      if (e.key !== 'Tab') return;

      /* Foco atrapado dentro del drawer, solo entre elementos visibles del nivel actual */
      var all = drawer.querySelectorAll(FOCUSABLE);
      var focusable = [];
      for (var i = 0; i < all.length; i++) {
        if (isVisible(all[i])) focusable.push(all[i]);
      }
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    /* Si el viewport pasa a escritorio con el drawer abierto, se cierra */
    function onDesktopChange(e) {
      if (e.matches) closeDrawer();
    }
    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', onDesktopChange);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(onDesktopChange);
    }

    /* Limpieza al descargar la sección en el editor: cierra el drawer, libera el scroll y
       retira el único listener que vive fuera del contenedor */
    function destroy() {
      closeDrawer();
      if (heightObserver) heightObserver.disconnect(); else window.removeEventListener('resize', updateHeight);
      document.documentElement.style.setProperty(HEIGHT_VAR, '0px');
      if (desktopQuery.removeEventListener) {
        desktopQuery.removeEventListener('change', onDesktopChange);
      } else if (desktopQuery.removeListener) {
        desktopQuery.removeListener(onDesktopChange);
      }
      instances.delete(container);
    }

    /* Cierra el panel de escritorio abierto si el clic cae fuera de su pestaña */
    function closeTabsOutside(target) {
      if (!container.querySelector('.' + OPEN_CLASS)) return;
      var tab = target.closest('[data-md-tab]');
      if (tab && container.contains(tab)) return;
      closeTabs(null);
    }

    instances.set(container, { toggle: toggleDrawer, closeTabsOutside: closeTabsOutside, destroy: destroy });
  }

  /* Único listener en document: la hamburguesa está en la sección MD Cabecera.
     Se filtra por aria-controls y se delega en la instancia dueña del drawer. El mismo listener
     cierra el panel de escritorio al pulsar fuera (en táctil no hay focusout que lo cierre). */
  document.addEventListener('click', function (e) {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;
    var container = drawer.closest(ROOT);
    var api = container && instances.get(container);
    if (!api) return;

    var trigger = e.target.closest(TRIGGER);
    if (trigger) {
      e.preventDefault();
      api.toggle(trigger);
      return;
    }
    api.closeTabsOutside(e.target);
  });

  var sections = document.querySelectorAll(ROOT);
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(ROOT);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(ROOT);
    var api = section && instances.get(section);
    if (api) api.destroy();
  });
})();
